import { Link } from "react-router-dom";
import SafeImage from "@/components/SafeImage";
import fallbackCover from "@/static/images/bg-a01.jpg";
import { cdnUrl } from "@/utils";
import "./styles/header.scss";

export default function Header({
    headobj = {},
    searchOpen = false,
    onSearchToggle = null,
}) {
    const {
        bgimg,
        bgimgSrcSet,
        avatar,
        title = "成长碎碎念",
        talks = "把日常写成我们的成长时间线",
        saynum = 0,
    } = headobj;
    const isLogin = window.location.hash.includes("login");

    return (
        <header className={`head ${isLogin ? "none" : ""}`}>
            <SafeImage
                className="head__cover"
                src={bgimg}
                srcSet={bgimgSrcSet || undefined}
                sizes="(min-width: 768px) 1180px, 100vw"
                fallbackSrc={fallbackCover}
                alt=""
                aria-hidden="true"
            />
            <div className="head__shade" aria-hidden="true" />
            {!!onSearchToggle && (
                <button
                    type="button"
                    className={`head__search ${searchOpen ? "active" : ""}`.trim()}
                    onClick={onSearchToggle}
                    aria-label={searchOpen ? "收起搜索" : "搜索记录"}
                    aria-expanded={searchOpen}
                >
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="11" cy="11" r="7" fill="none" />
                        <line x1="16.5" y1="16.5" x2="21" y2="21" />
                    </svg>
                </button>
            )}
            <div className="head__content">
                <Link className="avatar" to="/about" aria-label="查看关于页面">
                    <SafeImage src={cdnUrl(avatar)} alt="家庭头像" />
                </Link>
                <div className="head__copy">
                    <span className="name">{title}</span>
                    <span className="talks">{talks}</span>
                </div>
                <span className="count">{saynum} 条成长记录</span>
            </div>
        </header>
    );
}
